export default {
  languages: [],
  languagesWithTemplates: [],
  totalLanguagesWithTemplates: 1,
  paginatedLanguages: {},
  paginatedLanguagesTotal: 1,
  dtLanguage:[]
}